import { Injectable } from '@angular/core';
import {RestHttpService} from "@catcore/services/rest-http.service";
import {Restangular} from "ngx-restangular";
import {Observable} from "rxjs";

@Injectable()
export class FeatureGgwFixedRoutesService  extends RestHttpService<any> {

  constructor(service: Restangular) {
    super('feature-ggw-fixed-routes', service);
  }

  create(item: any): Observable<any> {
    return this.queryAll()
      .post({
        source: item.source._links.self.href,
        output: item.output,
        sink: item.sink._links.self.href,
        input: item.input,
      })
      .map((createdFeature) => {
        return createdFeature;
      });
  }

  /**
   * Concat two arrays by keeping the result array unique
   * Can only be used for inputs/outputs
   * Array elements must fit structure used for cat-dropdowns: => {label: 'string', value: any}
   * Label will be used for comparison only
   *
   * @param arr1
   * @param arr2
   * @returns {any[]}
   */
  public concatArraysUnique(arr1, arr2) {
    const res = [...arr1];
    let found = false;
    arr2.forEach((element: any) => {
      found = res.some((resElem: any) => {
        return resElem.label === element.label;
      });
      if (!found) {
        res.push(element);
      }
    });
    return res;
  }

  /**
   * Extract input options depending on the device.
   * Determination is done by name as this is fix in model.
   *
   * @param ggwDevice
   * @returns {any[]}
   */
  public extractInputOptions(ggwDevice: any) {
    switch (true) {
      case ggwDevice.name.toLowerCase().includes('gui'):
        return ggwDevice.gui_pages.map((page) => {
          return { label: page, value: page };
        });
      default:
        return [];
    }
  }

}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_develop@2/app/Resources/Public/src/app/modules/models/ggw-fixed-routes/services/feature-ggw-fixed-routes.service.ts